import Layout from '@/page/index/';
export default [
  {
    path: '/wel',
    component: Layout,
    redirect: '/wel/index',
    children: [
      {
        path: 'index',
        name: '首页',
        component: () => import(/* webpackChunkName: "views" */ '@/page/wel'),
      },
    ],
  },
  {
    path: '/amis',
    component: Layout,
    children: [
      {
        path: 'detail/:id',
        name: '低代码详情页',
        component: () =>
          import(/* webpackChunkName: "views" */ '@/views/amis/index'),
      },
    ],
  },
  {
    path: '/demo',
    component: () => import(/* webpackChunkName: "views" */ '@/page/demo'),
  },
  {
    path: '/info',
    component: Layout,
    // redirect: '/info/index',
    children: [
      {
        path: 'index',
        name: '个人信息',
        component: () =>
          import(/* webpackChunkName: "page" */ '@/views/admin/user/info'),
      },
    ],
  },
  {
    path: '/message',
    component: Layout,
    redirect: '/message/index',
    // component: resolve => require(['@/views/dot/message/index'], resolve)
  },
];
